import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

import MChartMultiV2 from './MChartMulti'
import MTableAdvancedV2 from './MTableAdvancedV2'

class Analytics extends Component {
  render() {
    const {
      classes,
      settings,
      data: { tableData, chartData, currency },
    } = this.props

    return (
      <div className={classes.dashboard}>
        <div className={classes.chartMulti}>
          <div className={classes.chartWrapper}>
            <MChartMultiV2 data={chartData} currency={currency} />
          </div>
        </div>
        <MTableAdvancedV2 data={tableData} settings={settings} currency={currency} />
      </div>
    )
  }
}

const styles = theme => ({
  dashboard: {
    paddingTop: 100,
  },
  chartWrapper: {
    position: 'absolute',
    top: 15,
    left: 10,
    right: 20,
    bottom: 15,
  },
  chartMulti: {
    position: 'relative',
    height: 0,
    margin: '0 10px 10px 10px',
    overflow: 'hidden',
    maxWidth: '100%',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    padding: '16px 20px',
    backgroundColor: '#fff',
    paddingBottom: '25%',
  },
})

export default withStyles(styles)(Analytics)
